import { FC } from 'react';
import { Link } from 'react-router-dom';

type Props = {
  variant?: 'home' | 'measurements';
};

const ComplexDesignsDisclaimer: FC<Props> = ({ variant = 'home' }) => {
  return (
    <p
      className={` ${
        variant !== 'home' ? 'text-medium-grey text-[14px] text-left' : 'text-black text-[14px] text-center'
      }`}
    >
      We also offer designs for more complex designs like hipped roofs. To receive a design for this please,{' '}
      <Link
        to="https://www.wienerberger.co.uk/about-us/contact.html"
        className="underline hover:text-red"
        target="_blank"
      >
        contact us
      </Link>
      .
    </p>
  );
};

export default ComplexDesignsDisclaimer;
